import { FC, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';

import useAIQuestion from '../../../hooks/useAIQuestion';
import useChat from '../../../hooks/useChat';
import { storeName } from '../../../redux/models/layout.model';
import { CHAT_ELEMENT_ID } from '../../constants';

const ChatWithAI: FC = () => {
  useChat();
  useAIQuestion();
  const positionRight = 16;
  const widthRightPanel = 376;

  const chatRef = useRef<HTMLDivElement>();
  const isShowRightPanel = useSelector((state) => state[storeName].isShowRightPanel);
  const chatScriptLoaded = useSelector((state) => state[storeName].chatScriptLoaded);
  const visible = useSelector((state) => state[storeName].chatVisible);

  useEffect(() => {
    if (!chatRef.current?.style) return;

    if (!isShowRightPanel) {
      chatRef.current.style.right = `${positionRight}px`;
    } else {
      chatRef.current.style.right = `${positionRight + widthRightPanel}px`;
    }
  }, [isShowRightPanel, chatScriptLoaded]);

  return (
    <div ref={chatRef} className={cx({ 'chatbox-hidden': !visible })} id={CHAT_ELEMENT_ID}></div>
  );
};

export default ChatWithAI;
